import Enum from 'enum'

export const audienceOptions = new Enum({
  EVERYONE: {
    display: 'Everyone',
    long: 'This chat is available to everyone who visits your website.'
  },
  USERS: {
    display: 'Known Users',
    long: 'This chat is available to known users who visit your website.'
  },
  SEGMENT: {
    display: 'Choose a Segment',
    long: 'This chat is available to SEGMENT who visit your website.'
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/MultiSegmentSelect/Constants.js